(function(){
     'use strict';

     angular
        .module('appback')
        .factory('NotificacionesService', NotificacionesService);

    NotificacionesService.$inject = ['$http'];

    function NotificacionesService($http){

        var service= {
           getNotificacionesCentro:getNotificacionesCentro
        };

        return service;
 		function getNotificacionesCentro(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getnotificacionescentro', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();